<template>
  <div class="DownloadData">
    <div class="row justify-content-center">
      <div class="col-md-12">
        <br/>
        <div style="display:block">
          <MDBDropdown v-model="dropdown1">
            <MDBDropdownToggle @click="dropdown1 = !dropdown1">
              {{ $t('download.image.title') }}
            </MDBDropdownToggle>

            <MDBDropdownMenu aria-labelledby="dropdownMenuButton">
              <MDBDropdownItem href="#" @click.prevent="onPrintMatrixOnly">
                {{ $t('download.image.crosswalkOnly') }}
              </MDBDropdownItem>
              <MDBDropdownItem href="#" @click.prevent="onPrintAll">
                {{ $t('download.image.allContent') }}
              </MDBDropdownItem>
            </MDBDropdownMenu>
          </MDBDropdown>

          <br/>

          <MDBBtn color="primary" class="mt-2" @click="onDownloadCsv">
            {{ $t('download.data.csv') }}
          </MDBBtn>
        </div>
      </div>
    </div>
  </div>
</template>

<script src="./_DownloadData.js" lang="js"></script>
<style src="./_DownloadData.less" lang="less" scoped></style>
